/*emTheme.js*-------------------*/
(function($) {
  var $body,
    $nav,
    $content,
    $a,
    $btnS,
    $closeBtn,
    $openCart,
    isOpen = false,
    emTheme = {
      init: function() {
        $btnS.click(function(e){
          e.preventDefault();
          $(this).toggleClass('open');
          $('.site-search').toggleClass('show').find('input[type=search]').val('');
        });

        $openCart.click(function(e){
          e.preventDefault();
          e.stopPropagation();
          emTheme.toggleMenu();
          $content.on( 'click.lnfClose', function(ev) {
      			var target = ev.target;
      			if( isOpen && target !== $openCart ) {
              emTheme.toggleMenu();
      			}
            $content.off('click.lnfClose');
      		} );

        });

        if( $closeBtn ) {
    			$closeBtn.click(function(){
            emTheme.toggleMenu();
          });
    		}

      },
      toggleMenu : function(){
        if( isOpen ) {
          $('body').removeClass('show-menu' );
          //$content.off('click.lnf');
        }
        else {
          $('body').addClass('show-menu' );
        }
        isOpen = !isOpen;
      },
    };



  $(document).ready(function() {
    $body = $('body'),
    $nav = $('#site-navigation'),
    $a = $('#primary'),
    $btnS = $('#menu-search'),
    $content = $('.content-wrap'),
    $closeBtn = $('#closeButton'),
    $openCart = $('#site-header-cart').find('li').first();
    emTheme.init();
    if (!$('body').is('.woocommerce-checkout')) {
        $('select').niceSelect();
    }

    $(".wpcf7-form-control-wrap").hover(function() {
      $(this).children(".wpcf7-not-valid-tip").css("display", "none");
    });

    $(".action-scroll").click(function(e) {
      e.preventDefault();
      anchor = $(this).attr("href");
      scrollOffset = parseInt($(anchor).offset().top - $('.content-wrap').scrollTop());
      //h = $(window).height();
      //alert(scrollOffset);
      //scrollOffset = $(anchor)[0].offsetTop + $(".right")[0].offsetTop;
      //alert(scrollOffset);
      $(".content-wrap").animate(
        { scrollTop: scrollOffset },
        1000
      );
    });

    /*$('.echantillon-link').click(function(e){
      e.preventDefault();
      alert('Commande Echantillon !');
    });*/ 

    $('#menu-item-161>a').click(function(e){
      e.preventDefault();
    });

    $('.noclic>a').click(function(e){
      e.preventDefault();
    });

    $open = $("#menu-responsive");
    $open.click(function(e) {
      e.preventDefault();
      $open.toggleClass("is-active");
      $body.toggleClass("menu-open");
    });

  });

})(jQuery);
